import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { DIAS_SEMANA } from "../horariosClubesComponentConstants";
import { LoadingStates } from "../horariosClubesComponentTypes";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  selectedDia: string | null;
  horaInicio: string;
  horaFin: string;
  onHoraInicioChange: (hora: string) => void;
  onHoraFinChange: (hora: string) => void;
  onGuardar: () => void;
  loadingStates: LoadingStates;
  isAnyOperationInProgress: () => boolean;
}

const ModalHorario: React.FC<Props> = ({
  isOpen,
  toggle,
  selectedDia,
  horaInicio,
  horaFin,
  onHoraInicioChange,
  onHoraFinChange,
  onGuardar,
  loadingStates,
  isAnyOperationInProgress
}) => {
  const diaEncontrado =
    selectedDia && DIAS_SEMANA.find(d => d.key === selectedDia);
  const nombreDia = diaEncontrado ? diaEncontrado.nombre : "";

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Configurar Horario - {nombreDia}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Hora de Inicio</Label>
              <Input
                type="time"
                value={horaInicio}
                onChange={e => onHoraInicioChange(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Hora de Fin</Label>
              <Input
                type="time"
                value={horaFin}
                onChange={e => onHoraFinChange(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
        <Button
          color="danger"
          onClick={onGuardar}
          disabled={isAnyOperationInProgress()}
        >
          {loadingStates.updating ? <>Guardando...</> : "Guardar Horario"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalHorario;
